import { GridCellParams, GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';
import { RingSizeGroup } from 'types/enums';

const getFilterParams = () => ({
  getApplyFilterFn: (filterItem: GridFilterItem) => {
    if (!filterItem.field || !filterItem.operator) {
      return null;
    }

    return (params: GridCellParams<unknown, number>) => {
      const [lowerValue, higherValue] = filterItem.operator.split('-');

      return params.value >= +lowerValue && params.value <= +higherValue;
    };
  },
  InputComponentProps: { type: 'number' },
});

export const getPatientRingSizeFilters = (): GridFilterOperator[] => {
  return Object.values(RingSizeGroup).map((value) => {
    return {
      label: value,
      value: value,
      ...getFilterParams(),
    };
  });
};
